<template>
  <div class="mc-result-page">
    <div class="mc-result-page__body">
      Ваш заказ № {{ id }} принят. Сертификат будет отправлен по почте после оплаты.
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      id: false
    }
  },
  mounted() {

  },
  created() {
    this.id = this.$route.query.id
  },
  components: {},
  methods: {
  },
}
</script>

